<template>
    <Card>
      <LocalDataTable
          ajax-link="admin/productCategory/List"
          :columns="columns"></LocalDataTable>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
export default {
  name: "ProductCategoryList",
  components: {LocalDataTable, Card, MasterLayout},
  data(){
    return{
      columns : [{title : 'عنوان'},{title : 'عنوان انگلیسی'},
        {title : 'سردسته'},{title : 'صنف'},{title : '<i class="far fa-cogs"></i>'}],
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('دسته بندی های محصولات');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>